// Physical LE store locations constants

export type Store = {
  name: string;
  displayName: string;
  utmMedium: string;
  spoofable: boolean;
};

export type Stores = {
  [key: string]: Store;
};

const stores: Stores = {
  chadstone_store: {
    name: 'Chadstone',
    displayName: 'Chadstone Store',
    utmMedium: 'chadstone_store',
    spoofable: true,
  },
  bondi_store: {
    name: 'Bondi',
    displayName: 'Bondi Store',
    utmMedium: 'bondi_store',
    spoofable: true,
  },
  le_live: {
    name: 'LE LIVE',
    displayName: 'LE LIVE',
    utmMedium: 'lelive',
    spoofable: false,
  },
};

export default stores;
